import React from 'react'

const Error = () => {
  return (
    <div>Oops!! Something went wrong.</div>
  )
}

export default Error